'use strict';

/**
 * @desc gets the max input value
 * @param {jqueryObject} qtyInput - jquery selector of input field
 * @returns {int} the max value
 */
function getQtyMaxValue(qtyInput) {
    return parseInt(qtyInput.attr('max'), 0);
}

/**
 * @desc gets the min input value
 * @param {jqueryObject} qtyInput - jquery selector of input field
 * @returns {int} the min value
 */
function getQtyMinValue(qtyInput) {
    return parseInt(qtyInput.attr('min'), 0);
}

/**
 * @desc warns user if desired quantity is close to product inventory
 * @param {string} pid - product id
 * @param {string} url - url of request
 * @param {int} updatedValue - qty value
 */
function warnNearInventoryLimit(pid, url, updatedValue) {
    $.ajax({
        url: url,
        method: 'GET',
        data: {
            pid: pid,
            qty: updatedValue
        },
        dataType: 'json',
        success: (data) => {
            if (data.outsideInventory) {
                $('body').append('<div class="alert alert-warning qty-alert" role="alert">' + data.msg + '</div>');
                setTimeout(function () {
                    $('.qty-alert').remove();
                }, 5000);
            }
        }
    });
}

/**
 * @desc quantity increase
 * @param {jqueryObject} qtyInput - jquery selector of input field
 * @param {string} pid - product id
 */
function qtyIncrease(qtyInput, pid) {
    var dataInv = $('.modal.show .product-quickview').attr('data-inv');
    var prodId = (dataInv && dataInv.length > 0 ? dataInv : pid);
    var qtyMax = getQtyMaxValue(qtyInput);
    var updatedValue = parseInt(qtyInput.val(), 10) + 1;
    if (updatedValue <= qtyMax) {
        qtyInput.val(updatedValue);
        var url = qtyInput.parents('.quantity-form').data('action-url');
        if (url !== '') {
            warnNearInventoryLimit(prodId, url, updatedValue);
        }
    }
}

/**
 * @desc quantity decrease
 * @param {jqueryObject} qtyInput - jquery selector of input field
 */
function qtyDecrease(qtyInput) {
    var qtyMin = getQtyMinValue(qtyInput);
    var updatedValue = parseInt(qtyInput.val(), 10) - 1;
    if (updatedValue >= qtyMin) {
        qtyInput.val(updatedValue);
    }
}

/**
 * Handles a user physically typing in more or less that the max or min
 * @param {jqueryObject} qtyInput - jquery selector of input field
 * @param {string} pid = product id
 */
function qtyTextUpdate(qtyInput, pid) {
    var qtyMax = getQtyMaxValue(qtyInput);
    var qtyMin = getQtyMinValue(qtyInput);
    if (qtyInput.val() > qtyMax) {
        $('body').append('<div class="alert alert-warning qty-alert" role="alert">You cannot add more than ' + qtyMax + '.</div>');
        setTimeout(function () {
            $('.qty-alert').remove();
        }, 5000);
        qtyInput.val(qtyMax);
    }

    if (qtyInput.val() < qtyMin) {
        $('body').append('<div class="alert alert-warning qty-alert" role="alert">You cannot add less than ' + qtyMin + '.</div>');
        setTimeout(function () {
            $('.qty-alert').remove();
        }, 5000);
        qtyInput.val(qtyMin);
    }
    var url = qtyInput.parents('.quantity-form').data('action-url');
    warnNearInventoryLimit(pid, url, qtyInput.val());
}

module.exports = {
    pdpInit: function () {
        var $qtyInput = $('.prices-add-to-cart-actions .quantity-form #quantity, .attributes .quantity-form #quantity');
        var pid = $('.product-detail').data('pid');

        // Prevent multiple inits of events when selecting attributes
        $('body').off('click', '.prices-add-to-cart-actions .quantity-form .plus, .attributes .quantity-form .plus');
        $('body').off('click', '.prices-add-to-cart-actions .quantity-form .minus, .attributes .quantity-form .minus');

        $('body').on('click', '.prices-add-to-cart-actions .quantity-form .plus, .attributes .quantity-form .plus', function () {
            qtyIncrease($qtyInput, pid);
        });

        $('body').on('click', '.prices-add-to-cart-actions .quantity-form .minus, .attributes .quantity-form .minus', function () {
            qtyDecrease($qtyInput);
        });

        $('#quantity').on('blur', function () {
            qtyTextUpdate($qtyInput, pid);
        });
    },
    qvInit: function () {
        var $qtyInput = $('.quick-view-dialog .quantity-form #quantity');
        var pid = $('.product-quickview').data('pid');

        $('body').off('click', '.quick-view-dialog .quantity-form .plus').on('click', '.quick-view-dialog .quantity-form .plus', function () {
            qtyIncrease($qtyInput, pid);
        });

        $('body').on('click', '.quick-view-dialog .quantity-form .minus', function () {
            qtyDecrease($qtyInput);
        });

        $('body').on('blur', '#quantity', function () {
            qtyTextUpdate($qtyInput, pid);
        });
    },
    miniCartInit: function () {
        var $qtyInput = $('.minicart .quantity-form input[type="text"]');

        $('body').on('click', '.minicart .quantity-form .plus', function () {
            $qtyInput = $(this).siblings('input[type="text"]');
            qtyIncrease($qtyInput);

            if ($('.popover .cart').length || $('.cart-page').length) {
                $qtyInput.trigger('change');
            }
        });

        $('body').on('click', '.minicart .quantity-form .minus', function () {
            $qtyInput = $(this).siblings('input[type="text"]');
            qtyDecrease($qtyInput);

            if ($('.popover .cart').length || $('.cart-page').length) {
                $qtyInput.trigger('change');
            }
        });
    },
    miniCartDeInit: function () {
        $('body').off('click', '.minicart .quantity-form .plus');

        $('body').off('click', '.minicart .quantity-form .minus');
    },
    cartInit: function () {
        var $qtyInput = $('.cart-page .quantity-form input[type="text"]');

        $('body').on('click', '.cart-page .quantity-form .plus, .cart-page .quantity-form-SFL .plus', function () {
            $qtyInput = $(this).siblings('input[type="text"]');
            qtyIncrease($qtyInput);

            if ($('.popover .cart').length || $('.cart-page').length) {
                $qtyInput.trigger('change');
            }
        });

        $('body').on('click', '.cart-page .quantity-form .minus, .cart-page .quantity-form-SFL .minus', function () {
            $qtyInput = $(this).siblings('input[type="text"]');
            qtyDecrease($qtyInput);

            if ($('.popover .cart').length || $('.cart-page').length) {
                $qtyInput.trigger('change');
            }
        });
    }
};
